// @flow

// Actions
export const SHOW_IMPORT_JOBS_TOOL = '@hfty-import-jobs-tool/SHOW_IMPORT_JOBS_TOOL'
export const SHOW_IMPORT_JOBS_POPUP = '@hfty-import-jobs-tool/SHOW_IMPORT_JOBS_POPUP'

// Message keys
// Message keys -> ImportJobsForm
export const MSG_SEASON_LABEL = 'season'
export const MSG_FORM_HEADING = 'formHeading'
export const MSG_FORM_HINT_MESSAGE = 'hintMessage'
export const MSG_ERROR_FILE_REQUIRED = 'fileRequired'
export const MSG_ERROR_EXTRA_FILES = 'extraFiles'
export const MSG_ERROR_WRONG_EXTENSION = 'wrongExtension'
export const MSG_ERROR_MISSING_SEASON = 'missingSeason'
export const MSG_WARNING_WRONG_EXTENSION = 'wrongExtensionWarning'
export const MSG_WARNING_UNKNOWN = 'unknown'
// Message keys -> ImportJobsPopup
export const MSG_POPUP_HEADING = 'popupHeader'
export const MSG_JOB_IMPORT_FAILED = 'jobImportFailed'
export const MSG_JOBS_IMPORT_FAILED = 'jobsImportFailed'
export const MSG_SUCCESSFUL_IMPORT = 'successfulImport'
export const MSG_PARTIALLY_SUCCESSFUL_IMPORT = 'partiallySuccessfulImport'
export const MSG_OK_BUTTON = 'okButton'
export const MSG_SUBMIT_BTN = 'submit'
export const MSG_CANCEL_BTN = 'cancel'
